import React, { useEffect, useState } from 'react';
import Base from '../Base';
import Title from '../../components/common/Title';
import { useTranslation } from 'react-i18next';
import { fetchUserInfo } from '../../utils';
import Card from '../../components/elements/Card';
import Image from '../../components/images/Image';
import Icon from '../../components/common/Icon';
import Back from '../../components/common/Back';
import NotFound from '../../components/common/NotFound';

const EventSurveys = () => {
  const { t } = useTranslation();
  const [surveys, setSurveys] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch surveys for the user/event
  useEffect(() => {
    fetchUserInfo('/event-surveys', setSurveys, setLoading, setError, []);
  }, []);

  return (
    <Base activeNav="home">
      
      {/* Header */}
      <Card>
        <Back to="/home" />
        <Title>
          <Icon name='clipboard-list' className='me-2' style={{ fontSize: '24px' }} theme='primary' />
          {t('surveys')}
        </Title>
      </Card>

      {/* Content */}
      {loading ? (
        <NotFound translationKey="loading" loading={true} />
      ) : error ? (
        <NotFound translationKey="errorLoading" />
      ) : surveys && surveys.length > 0 ? (
        <>
          {surveys.map((survey) => {
            const now = new Date();
            const start = survey.start_date ? new Date(survey.start_date) : null;
            const end = survey.end_date ? new Date(survey.end_date) : null;

            // Active only if today is between start and end
            const isActive =
                (!start || now >= start) &&
                (!end || now <= end);

            return (
                <Card
                key={survey.id}
                to={isActive ? `/survey` : null}   // disable navigation
                onClick={() => {
                    if (isActive) sessionStorage.setItem('selectedSurveyId', survey.id);
                }}
                style={{
                    filter: isActive ? "none" : "grayscale(100%)",
                    opacity: isActive ? 1 : 0.55,
                    pointerEvents: isActive ? "auto" : "none"   // disables click completely
                }}
                >
                <div className='justify-content-between d-flex align-items-center'>

                    {/* Left side: image + name */}
                    <div className='d-flex align-items-center'>
                    <Image
                        size="5rem"
                        className='me-3'
                        url={
                        survey.picture_url
                            ? survey.picture_url
                            : require('./../../assets/images/fallback/survey.png')
                        }
                    />

                    <div className='d-flex flex-column text-start' style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        <div>{survey.name}</div>

                        <div className='text-muted' style={{ fontSize: '14px' }}>
                        <Icon name="calendar" className='me-1' />
                        {survey.start_date ? new Date(survey.start_date).toLocaleDateString() : '—'} - {survey.end_date ? new Date(survey.end_date).toLocaleDateString() : '—'}
                        </div>
                        {survey.completion_points > 0 && (
                          <div className='mt-1' style={{ fontSize: '13px', fontWeight: 'normal' }}>
                            <span className='badge bg-primary'>
                              <Icon name="star" className='me-1' />
                              {t('surveyEarnPoints', { points: survey.completion_points })}
                            </span>
                          </div>
                        )}
                        {survey.team_submitted && (
                          <div className='mt-1' style={{ fontSize: '13px', fontWeight: 'normal' }}>
                            <span className='badge bg-secondary'>
                              <Icon name="users" className='me-1' />
                              {t('quizTeamCompleted')}
                            </span>
                          </div>
                        )}
                    </div>
                    </div>

                    {/* CTA */}
                    <div
                    className='me-2 underline-primary'
                    style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        opacity: isActive ? 1 : 0.4
                    }}
                    >
                    {isActive ? t('start') : t('notAvailable')}
                    </div>

                </div>
                </Card>
            );
            })}

        </>
      ) : (
        <NotFound translationKey="noSurveysFound" loading={loading} />
      )}

    </Base>
  );
};

export default EventSurveys;
